import { useState, useEffect } from 'react';
import './WhoWeAre.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import about1 from '../assets/about1.jpeg';
import about2 from '../assets/about2.jpeg';
import about3 from '../assets/about3.jpeg';

function WhoWeAre() {
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: 'ease-out',
      once: false,
      mirror: true // allows animations to happen on scroll up as well
    });
  }, []);

  return (
    <div className="who-we-are-container">
      <div className="who-we-are-content">
        {/* LEFT SECTION WITH FADE LEFT */}
        <div
          className="left-section"
          data-aos="fade-left"        // fade in from left
          data-aos-once="false"
          data-aos-anchor-placement="top-center"
        >
          <div className="small-heading">About Sky Breeze</div>

          <h1 className="big-heading">
            Your Reliable Partner <span className="highlight">in Advanced AC Care</span>
          </h1>

          <p className="description">
            SkyBreeze AC Solutions is a professionally managed HVAC company with over 8+ years of industry experience, delivering reliable air-conditioning solutions for commercial, industrial, and residential projects across India. With a strong team of skilled technicians and a dedicated duct manufacturing unit, we specialize in end-to-end HVAC execution with a focus on quality, transparency, and long-term performance
          </p>

          {showMore && (
            <p className="description-extended">
              We are also proud BNI members, expanding our projects and partnerships through a strong business network and industry connections.
            </p>
          )}

          <button
            className="wread-more-btn"
            onClick={() => setShowMore(!showMore)}
          >
            {showMore ? 'Read Less' : 'Read More'} →
          </button>
        </div>

        {/* RIGHT SECTION (STATIC) */}
        <div className="right-section">
          <div className="images-grid">
            <div className="image-item image-1">
              <img src={about1} alt="AC Installation" />
            </div>
            <div className="image-item image-3">
              <img src={about2} alt="Professional Team" />
            </div>
            <div className="image-item image-3">
              <img src={about3} alt="Team Collaboration" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhoWeAre;
